var $a701758f24293d53$exports = {};
$a701758f24293d53$exports = {
  "help": "Hj\xE4lp",
  "info": "Information"
};
export { $a701758f24293d53$exports as default };